import { useState } from 'react';
import { signIn } from 'aws-amplify/auth';
import { LoginLayout } from './components/LoginLayout';
import PasswordField from './components/PasswordField';
import Input from "components/Input/Input";
import Checkbox from "components/Checkbox/Checkbox";
import Button from "components/Button/Button";

const MySignIn = ({ onNavigate }) => {
  const [error, setError] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleAuth = async (ev) => {
    ev.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const result = await signIn({ username, password });
      // If Cognito requires a new password, route to that screen
      if (result.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        onNavigate('forceNewPassword');
        return;
      }
      // signIn success triggers Hub 'signIn' event → page reload
    } catch (err) {
      // Amplify v6 cookie-storage race: signIn succeeded (Cognito issued
      // tokens, cookies were written) but Amplify's post-signin
      // dispatchSignedInHubEvent called getCurrentUser() before the new
      // cookies were readable on the client, so it throws
      // UnexpectedSignInInterruptionException. The session is real — a page
      // reload lets _app.js's tryGetCurrentUser retry pick it up.
      // Use a 30s sessionStorage guard so we never loop if cookies are
      // genuinely blocked (e.g. third-party cookie restrictions).
      if (err.name === 'UnexpectedSignInInterruptionException' && typeof window !== 'undefined') {
        const KEY = 'cv-cookie-race-recovery-at';
        const lastAt = parseInt(window.sessionStorage.getItem(KEY) || '0', 10);
        if (Date.now() - lastAt > 30_000) {
          window.sessionStorage.setItem(KEY, String(Date.now()));
          window.location.reload();
          return;
        }
        setError('Could not establish your session. Please clear cookies for this site and try signing in again.');
        setIsLoading(false);
        return;
      }
      setError(err.message || 'An error occurred');
      setIsLoading(false);
    }
  };

  const onInputChange = (event) => {
    setError('');
    if (event.target.name === 'username') {
      setUsername(event.target.value);
    } else if (event.target.name === 'password') {
      setPassword(event.target.value);
    }
  };

  return (
    <LoginLayout title={"Log in to Your Account"} errorMessage={error}>
      <form className="relative space-y-6 pt-4 pb-8 px-8" onSubmit={handleAuth}>
        <Input
          label="Email Address"
          isMediumFont={true}
          id="username"
          name="username"
          required={true}
          onChange={onInputChange}
          autoComplete="username"
        />
        <PasswordField
          onChange={(ev) => onInputChange(ev)}
          id="password"
          name="password"
          label="Password"
        />
        <div className="flex items-center justify-between">
          <Checkbox name="remember_me" id="remember_me" label="Remember me" />
          <button
            type='button'
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            onClick={() => onNavigate('forgotPassword')}
          >
            Forgot password?
          </button>
        </div>
        <Button
          type="submit"
          variant="primary"
          size="lg"
          isFullWidth={true}
          isTextCenter={true}
          loading={isLoading}
        >
          Log in
        </Button>
      </form>
    </LoginLayout>
  );
};

export default MySignIn;
